import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon, Button, Spin, Table } from 'antd';

import CollateralMember from '../CollateralMember';
import { getStakeAll } from '../../common/fetch';
import { EXCHANGE_CARD_ICON, XHT_ICON, XHT_REMOVAL_IN_PROCESS, XHT_ICON_ORANGE } from '../../config/media';
import { COLLATERAL_TOTAL_AMOUNT } from '../../config/constants';
import Wrapper from './style';
import Pledge from '../Pledge/Pledge';
import { getRemovalColumns } from '../CollateralStatus/Utils'

let holla_member = 500000;
let lite_member = 50000;
let tier_member = 0;

const CollateralStatus = ({
	exchange,
	collateral,
	onPubilc,
	onPledged,
	onWithdraw,
	onCopy,
	stat,
	updateCollateral
}) => {
	const [isOpenMember, setMemberOpen] = useState(false);
	const [isClosingPledge, setPledgeStatus] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const { is_collateralized, pledges } = collateral;
	const [removalData, setRemovalData] = useState([]);
	const [isOpen, setOpen] = useState(false);
	const [cancelData, setCancelData] = useState({});
	const [type, setType] = useState('');
	const [isMobile, setIsMobile] = useState(false);

	const requestPledges = useCallback(async (isInit = false) => {
		try {
			if (isInit) {
				setLoading(true);
			}
			const res = await getStakeAll();
			updateCollateral({ pledgesAll: res.data });
			if (isInit) {
				setLoading(false);
			}
		} catch (err) {
			if (isInit) {
				setLoading(false);
			}
		}
	}, [updateCollateral]);

	const handleResize = useCallback((e) => {
		const { innerWidth } = window;
		if (innerWidth <= 960 && !isMobile) {
			setIsMobile(true);
		} else if (innerWidth > 960 && isMobile) {
			setIsMobile(false);
		}
	}, [isMobile]);

	useEffect(() => {
		window.addEventListener('resize', handleResize);
		handleResize();
	}, [handleResize]);
	useEffect(() => {
		return () => {
			window.removeEventListener('resize', () => { });
		};
	}, []);
	useEffect(() => {
		requestPledges(true);
	}, [requestPledges]);
	useEffect(() => {
		const { pledges = [] } = collateral.pledgesAll || {};
		const closingPledge = pledges.filter(pledge => pledge.exchange_id === exchange.id && pledge.close_request !== null);
		setPledgeStatus(!!closingPledge.length);
		setRemovalData(closingPledge);
	}, [collateral.pledgesAll, exchange]);
	const { total = 0, mine = 0, count } = pledges;
	const others = total - mine;
	const myAmount = (mine / COLLATERAL_TOTAL_AMOUNT) * 100;
	const otherAmount = (others / COLLATERAL_TOTAL_AMOUNT) * 100;
	const tierMemberAmount = (tier_member / COLLATERAL_TOTAL_AMOUNT) * 100;
	const liteMemberAmount = (lite_member / COLLATERAL_TOTAL_AMOUNT) * 100;
	let hollaMemberAmount = (holla_member / COLLATERAL_TOTAL_AMOUNT) * 100;
	if (hollaMemberAmount > 100) {
		hollaMemberAmount = 100;
	}
	let imgIndex = 1;
	if (exchange && exchange.display_name) {
		imgIndex = (exchange.id % 6) + 1;
	}
	const handleMemberOption = () => {
		setMemberOpen(!isOpenMember);
	};

	const handleCancelRemove = (item) => {
		setOpen(true);
		setType("cancel-remove");
		setCancelData(item);
	}

	const onCancel = () => {
		setOpen(false);
		setType("");
	}

	if (isLoading) {
		return <Spin />;
	}
	return (
		<Wrapper
			tierMemberAmount={tierMemberAmount}
			liteMemberAmount={liteMemberAmount}
			hollaMemberAmount={hollaMemberAmount}
		>
			<div
				className={
					isClosingPledge
						? "block-ui-container blocked-ui"
						: ""
				}
			>
				{isClosingPledge
					? <div className={'block-ui-message'}>
						<img src={XHT_REMOVAL_IN_PROCESS} className="message-icon" alt="XHT-removal" />
						<div className="message-title-text">XHT removal in process</div>
						<div className="message-text">
							<div>Adding XHT stake during your removal process is not allowed.</div>
							<div>You can at anytime cancel the removal process below.</div>
						</div>
					</div>
					: null
				}
				<div className="collateral-amount-container">
					<div className="flex-between">
						<div className="collateral-infos">
							<div className="exchange-name info-text">
								<img
									src={EXCHANGE_CARD_ICON[imgIndex]}
									alt="Exchange logo"
									className="exchange-logo"
								/>
								{exchange.display_name}
							</div>
							<div className="info-text">
								<b>Current level:</b>{' '}
								{exchange.collateral_level}
							</div>
							{/* <span className="no-border">
								<b>
									{stat.amount === 0
										? 0
										: (total / stat.amount) * 100 >= 100
											? 100
											: ((total / stat.amount) * 100).toFixed(2)}
									%
								</b>
							</span> */}
							{/* <span>
								<b>Collateral Pledged: {mine + others} XHT</b>
							</span> */}
							<div className="info-text">
								<b>Status:</b> {is_collateralized ? 'Complete' : 'Incomplete'}{' '}
								<Icon type={is_collateralized ? 'lock' : 'unlock'} />
							</div>
							<div className="info-text">
								<Icon
									type="user"
									style={{ fontSize: '14px', color: '#fff' }}
								/>
								{count}
								<b> backers</b>
							</div>
							<div className="info-text no-border others">
								<div className="small-circle"></div>
								<b>Others have pledged:</b>{' '}
								<img src={XHT_ICON_ORANGE} className="xht-orange-icon" alt="XHT icon" />
								{others}{' XHT'}
							</div>
						</div>
						<div className="flex-center">
							<Button className="remove-btn" type="ghost" onClick={() => onWithdraw("remove", cancelData)}>
								Remove
							</Button>
							<Button type="primary" block onClick={() => onPledged("collateralize")}>
								Add
							</Button>
						</div>
					</div>
					{/* {is_public ? (
						<div className="public-text">
							<Button type="primary" block>
								<Link to={`/project/${id}`}>View Public Pitch Page</Link>
							</Button>
							<label className="copy-link" onClick={onCopy}>
								Share Exchange
								<input value={`${window.location.origin}/project/${id}`} />
							</label>
						</div>
					) : (
							<div className="btn-public">
								<Button type="info" block onClick={onPubilc}>
									Go Public
							</Button>
							</div>
						)} */}
					{/* <div className="collateral-amount-container-description">
						<h3>Exchange Collateral Status</h3>
						{is_collateralized ? (
							<p style={{ color: '#288500' }}>
								Exchange Successfully Collateralized
							</p>
						) : total === 0 ? (
							<p stlye={{ color: '#a9a9a9' }}>
								<Icon
									type="clock-circle"
									theme="filled"
									style={{ fontSize: '14px' }}
								/>
								Exchange is on a trial.&nbsp;
								<span className="link" onClick={onPledged}>
									Add XHT collateral
								</span>
								&nbsp;to continue using exchange
							</p>
						) : (
							<p stlye={{ color: '#a9a9a9' }}>
								<Icon
									type="clock-circle"
									theme="filled"
									style={{ fontSize: '14px' }}
								/>
								Exchange requires more pledged XHT to fully collateralize.
								<span className="link" onClick={onPubilc}>
									Go pubic
								</span>{' '}
								to raise more XHT.
							</p>
						)}
					</div> */}
					<div className="collater-progressbar">
						<div
							className="others-amount"
							style={{ width: `${otherAmount}%` }}
						></div>
						<div
							className="my-amount"
							style={{
								left: `${otherAmount}%`,
								width: `${myAmount}%`
							}}
						></div>
					</div>
					<div className="tier-member arrow-down"></div>
					<div className="lite-member arrow-down"></div>
					<div className="holla-member arrow-down"></div>
				</div>
				<div className="collateral-member-container">
					<div className="member-content member-tier-content">
						<div className={isMobile ? "small-text" : "title"}>XHT-0</div>
						{!isMobile
							?
							<div>
								<div className="member-description-title">Tier 0 member</div>
								<div>50% profit margins</div>
								<div>0 XHT</div>
							</div>
							: null
						}
						
					</div>
					<div className="member-content member-lite-content">
						<div className={isMobile ? "small-text" : "title"}>XHT-1</div>
						{!isMobile
							?
							<div>
								<div className="member-description-title">Lite member</div>
								<div>Increased profit margins</div>
								<div>Earn passive income from network</div>
								<div>Stake required: 50,000 XHT</div>
							</div>
							: null
						}
						
					</div>
					<div className="member-content member-holla-content">
						<div className={isMobile ? "small-text" : "title"}>XHT-2</div>
						{!isMobile
							?
							<div>
								<div className="member-description-title">Holla member</div>
								<div>Highest profit margins</div>
								<div>Earn passive income from network</div>
								<div>Stake required: 500,000 XHT</div>
							</div>
							: null
						}
						{/*<div className="configure-link" onClick={handleMemberOption}>Learn more</div>*/}
					</div>
				</div>
				<div className="collater-user-cotainer">
					<div className="user-area">
						<div className="blue-circle"></div>
						<div className="my">
							My XHT Staked:{' '}
							<img src={XHT_ICON} className="xht-icon" alt="XHT-icon" />
							<span>{mine}</span>
						</div>
					</div>
					<div className="collater-user-content">
						<p>
							Exchange staking have a mandatory removal period. When removing staked collateral from an exchange project a all new earnings will halt and removal duration of 1 year will apply.
						</p>
						<p>
							* <span>Earning rules:</span> All earnings only apply to owner of the tokens. For cloud exchange XHT collateral is covered by HollaEx foundation as marked as orange. To earn XHT you must stake XHT collateral on your own project or others. Your profit margins are dependent on the fees set on your customers.
						</p>
					</div>
					{/* <div className="btn-area">
					<Button type="primary" block onClick={onPledged}>
						Pledge XHT
					</Button>
					<span className="link" onClick={onWithdraw}>
						Withdraw XHT Pledge
					</span>
				</div> */}
				</div>
			</div>
			<div className="flex-between footer-content">
				{isClosingPledge
					?
					<div>
						<div className="member-description-title">
							Stake in removal process
						</div>
						<div>
							Unstaking takes time and any amount being removed will stop all earnings.
						</div>
					</div>
					:
					<div>
						<div className="member-description-title">
							Total staked in all projects
						</div>
						<div>Total staked {' '}{total} XHT</div>
					</div>
				}
				<div>
					<Link to="/wallet?type=2">Go to stake page</Link>
				</div>
			</div>
			{isClosingPledge
				?
				<div className='table-container'>
					<Table
						columns={getRemovalColumns(handleCancelRemove, false)}
						dataSource={removalData.length ? removalData : null}
						rowKey={(data) => {
							return data.id;
						}}
						pagination={false}
					/>
				</div>
				: null
			}
			<Link to="/wallet?type=2">View more staking details</Link>
			{isOpenMember
				? <CollateralMember
					isVisible={isOpenMember}
					handleCancel={handleMemberOption}
				/>
				: null
			}
			<Pledge
				visible={isOpen}
				exchange={exchange}
				collateral={collateral}
				type={type}
				cancelData={cancelData}
				onCancel={onCancel}
				getStakeAllData={requestPledges}
			/>
		</Wrapper>
	);
};

export default CollateralStatus;
